import { styled, useTheme } from '@aibi-ui/core';
import Modal from 'src/components/Modal';
import { useEffect, useRef, useState } from 'react';
import { getChartDataAPI, getChartDetailAPI } from 'src/api/backstage';
import ChartContainer from '../../../../components/Chart/ChartContainer';
import { generateRandomString } from '../../../../conversation/utils';
import { AntdTable } from '../../../../components';
import { buildV1ChartDataPayload } from '../../../../explore/exploreUtils';

const DatasetPreview = ({ showModal, setShowModal, sliceId }) => {
  const theme = useTheme();

  const closeModal = () => {
    setShowModal(false);
  };

  const [modalHeight, setModalHeight] = useState(400);
  const getModalHeight = () => {
    setTimeout(() => {
      setTimeout(() => {
        const modalEl = document.querySelector('.ant-modal-body'); // 确保这里的选择器正确
        if (modalEl) {
          setModalHeight(modalEl.offsetHeight);
        }
      }, 0);
    }, 0);
  };

  const [queriesResponse, setQueriesResponse] = useState(null);
  const [formData, setFormData] = useState(null);
  const [vizType, setVizType] = useState(null);

  const [dataSource, setDataSource] = useState([]);
  const [columns, setColumns] = useState([]);

  /**
   * 获取图表数据
   * @returns {Promise<void>}
   */
  const getChartData = async () => {
    try {
      const {
        json: { result },
      } = await getChartDetailAPI(sliceId);
      setVizType(result.form_data.viz_type);
      setFormData(result.form_data);
      const searchParams = { form_data: JSON.stringify({ slice_id: sliceId }) };
      const jsonPayload = buildV1ChartDataPayload({
        formData: result.form_data,
        force: false,
        resultFormat: 'json',
        resultType: 'full',
        setDataMask: null,
        ownState: null,
      });
      const chartRes = await getChartDataAPI({ searchParams, jsonPayload });
      setQueriesResponse(chartRes.json.result);
      if (result.form_data.viz_type === 'table') {
        const columns = chartRes.json.result[0].colnames.map(r => ({
          title: r,
          key: r,
          dataIndex: r,
        }));
        const dataSource = chartRes.json.result[0].data;
        setColumns(columns);
        setDataSource(dataSource);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (showModal) {
      getModalHeight();
      getChartData();
    }
  }, [showModal]);

  const renderChart = () => {
    if (vizType && formData && queriesResponse) {
      if (vizType === 'table') {
        return (
          <AntdTable
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            scroll={{ y: modalHeight - 120 }}
          />
        );
      }
      return (
        <ChartContainer
          chartId={sliceId}
          id={sliceId}
          width="100%"
          height={modalHeight - 60}
          queriesResponse={queriesResponse}
          formData={formData}
          vizType={vizType}
        />
      );
    }
    return <></>;
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      closable
      title="图表预览"
      width="50vw"
      height="65vh"
      hideFooter
      draggable
      destroyOnClose
    >
      {renderChart()}
    </Modal>
  );
};

export default DatasetPreview;
